/* eslint-disable import/no-named-as-default-member */
/* Setting sagas */

import { call, put, takeLatest } from "redux-saga/effects"

import ErrorsActions from "../../Redux/ErrorsRedux"
import { apiGeneratorBase } from "../../Utils/saga"
import AuthActions from "../LoginPage/reducer"
import UserCreators from "../User/reducer"
import Creators, { SettingTypes as constants } from "./reducer"
import * as services from "./services"

const actions = {
  getLanguagesListActions: {
    request: Creators.getLanguagesListRequest,
    success: Creators.getLanguagesListSuccess,
    errors: Creators.getLanguagesListFailure
  },
  getNotificationsListActions: {
    request: Creators.getNotificationsListRequest,
    success: Creators.getNotificationsListSuccess,
    errors: Creators.getNotificationsListFailure
  },
  changeNotificationsListActions: {
    request: Creators.changeNotificationsListRequest,
    success: Creators.changeNotificationsListSuccess,
    errors: Creators.changeNotificationsListFailure
  },
  getUserCountryActions: {
    request: Creators.getUserCountryRequest,
    success: Creators.getUserCountrySuccess,
    errors: Creators.getUserCountryFailure
  },
  navToStripeActions: {
    request: Creators.navToStripeRequest,
    success: Creators.navToStripeSuccess,
    errors: Creators.navToStripeFailure
  },
  getUsersManagementActions: {
    request: Creators.getUsersManagementRequest,
    success: Creators.getUsersManagementSuccess,
    errors: Creators.getUsersManagementFailure
  },
  getUsersManagementRolesActions: {
    request: Creators.getUsersManagementRolesRequest,
    success: Creators.getUsersManagementRolesSuccess,
    errors: Creators.getUsersManagementRolesFailure
  },
  createInviteUserActions: {
    request: Creators.createInviteUserRequest,
    success: Creators.createInviteUserSuccess,
    errors: Creators.createInviteUserFailure
  },
  updateInviteUserActions: {
    request: Creators.updateInviteUserRequest,
    success: Creators.updateInviteUserSuccess,
    errors: Creators.updateInviteUserFailure
  },
  resendInviteUserActions: {
    request: Creators.resendInviteUserRequest,
    success: Creators.resendInviteUserSuccess,
    errors: Creators.resendInviteUserFailure
  },
  removeUserActions: {
    request: Creators.removeUserRequest,
    success: Creators.removeUserSuccess,
    errors: Creators.removeUserFailure,
    extraAction: [UserCreators.getBusinessAccountsWithRoleRequest, UserCreators.userRequest]
  },
  getInviteUserInfoActions: {
    request: Creators.getInviteUserInfoRequest,
    success: Creators.getInviteUserInfoSuccess,
    errors: Creators.getInviteUserInfoFailure
  },
  rejectInviteUserActions: {
    request: Creators.rejectInviteUserRequest,
    success: Creators.rejectInviteUserSuccess,
    errors: Creators.rejectInviteUserFailure,
    extraAction: [UserCreators.userRequest]
  },
  logoutInviteUserActions: {
    request: Creators.logoutInviteUserRequest,
    success: Creators.logoutInviteUserSuccess,
    errors: Creators.logoutInviteUserFailure
  },
  acceptInviteUserActions: {
    request: Creators.acceptInviteUserRequest,
    success: Creators.acceptInviteUserSuccess,
    errors: Creators.acceptInviteUserFailure,
    extraAction: [UserCreators.getBusinessAccountsWithRoleRequest, UserCreators.userRequest]
  }
}

const eventsOptions = {
  [constants.GET_LANGUAGES_LIST_REQUEST]: {
    api: services.getLanguagesList,
    actions: actions.getLanguagesListActions
  },
  [constants.GET_NOTIFICATIONS_LIST_REQUEST]: {
    api: services.getNotificationsList,
    actions: actions.getNotificationsListActions
  },
  [constants.CHANGE_NOTIFICATIONS_LIST_REQUEST]: {
    api: services.changeNotificationsList,
    actions: actions.changeNotificationsListActions
  },
  [constants.GET_USER_COUNTRY_REQUEST]: {
    api: services.getUserCountry,
    actions: actions.getUserCountryActions
  },
  [constants.NAV_TO_STRIPE_REQUEST]: {
    api: services.navToStripe,
    actions: actions.navToStripeActions
  },
  [constants.GET_USERS_MANAGEMENT_REQUEST]: {
    api: services.getUsersManagement,
    actions: actions.getUsersManagementActions
  },
  [constants.GET_USERS_MANAGEMENT_ROLES_REQUEST]: {
    api: services.getUsersManagementRoles,
    actions: actions.getUsersManagementRolesActions
  },
  [constants.CREATE_INVITE_USER_REQUEST]: {
    api: services.createInviteUserManagement,
    actions: actions.createInviteUserActions
  },
  [constants.UPDATE_INVITE_USER_REQUEST]: {
    api: services.updateInviteUserManagement,
    actions: actions.updateInviteUserActions
  },
  [constants.RESEND_INVITE_USER_REQUEST]: {
    api: services.resendInviteUserManagement,
    actions: actions.resendInviteUserActions
  },
  [constants.REMOVE_USER_REQUEST]: {
    api: services.removeUserManagement,
    actions: actions.removeUserActions
  },
  [constants.GET_INVITE_USER_INFO_REQUEST]: {
    api: services.getInviteUserInfo,
    actions: actions.getInviteUserInfoActions
  },
  [constants.REJECT_INVITE_USER_REQUEST]: {
    api: services.rejectInviteUser,
    actions: actions.rejectInviteUserActions
  },
  [constants.ACCEPT_INVITE_USER_REQUEST]: {
    api: services.acceptInviteUser,
    actions: actions.acceptInviteUserActions
  },
  [constants.LOGOUT_INVITE_USER_REQUEST]: {
    api: services.logoutInviteUser,
    actions: actions.logoutInviteUserActions
  }
}

function* apiGenerator(action) {
  const provider = eventsOptions[action.type]

  try {
    const params = action.payload
    const response = yield call(provider.api, params)

    if (response.data) {
      if (response.ok) {
        yield put(provider.actions.success(response.data))
        if (action.type === constants.NAV_TO_STRIPE_REQUEST && response.data.url)
          window.location.href = response.data.url

        if (response?.data?.id) {
          if (action.type === constants.GET_USER_COUNTRY_REQUEST) {
            yield put(AuthActions.updateProfile({ userCountry: response.data }))
          } else {
            yield put(AuthActions.updateProfile(response.data))
          }
        }
      } else {
        yield put(provider.actions.errors({ errors: response.data }))
        if (action.type === constants.NAV_TO_STRIPE_REQUEST) {
          yield put(ErrorsActions.errorSave(response.data))
        }
      }
    } else {
      yield put(provider.actions.errors({ errors: "some error" }))
    }
  } catch (errors) {
    yield put(provider.actions.errors({ errors }))
  }
}

function* createInviteUserSaga(action) {
  const provider = eventsOptions[action.type]
  try {
    const { business_account_id, onSuccess, ...params } = action.payload
    const response = yield call(provider.api, params)
    if (response.ok && response.data) {
      yield put(provider.actions.success(response.data))
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess(response.data)
      }
      yield put(Creators.getUsersManagementRequest({ business_account_id }))
    } else {
      yield put(
        provider.actions.errors(
          response.data?.message?.detail || response.data?.message || response.data?.detail?.[0]
        )
      )
      const error = response.data
      yield put(ErrorsActions.errorSave(response.status === 500 ? "Server response error" : error))
    }
  } catch (errors) {
    yield put(provider.actions.errors())
    yield put(ErrorsActions.errorSave({ errors }))
  }
}

function* updateInviteUserSaga(action) {
  const provider = eventsOptions[action.type]
  try {
    const { business_account_id, onSuccess, ...params } = action.payload
    const response = yield call(provider.api, params)
    if (response.ok && response.data) {
      yield put(provider.actions.success(response.data))
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess(response.data)
      }
      yield put(Creators.getUsersManagementRequest({ business_account_id }))
      yield put(UserCreators.getBusinessAccountsWithRoleRequest())
      yield put(UserCreators.userRequest())
    } else {
      yield put(
        provider.actions.errors(
          response.data?.message?.detail || response.data?.message || response.data?.detail?.[0]
        )
      )
      const error = response.data
      yield put(ErrorsActions.errorSave(response.status === 500 ? "Server response error" : error))
    }
  } catch (errors) {
    yield put(provider.actions.errors())
    yield put(ErrorsActions.errorSave({ errors }))
  }
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_LANGUAGES_LIST_REQUEST, apiGenerator)
  yield takeLatest(constants.GET_NOTIFICATIONS_LIST_REQUEST, apiGenerator)
  yield takeLatest(constants.CHANGE_NOTIFICATIONS_LIST_REQUEST, apiGenerator)
  yield takeLatest(constants.GET_USER_COUNTRY_REQUEST, apiGenerator)
  yield takeLatest(constants.NAV_TO_STRIPE_REQUEST, apiGenerator)
  yield takeLatest(constants.GET_USERS_MANAGEMENT_ROLES_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_USERS_MANAGEMENT_ROLES_REQUEST])
  )
  yield takeLatest(constants.GET_USERS_MANAGEMENT_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_USERS_MANAGEMENT_REQUEST])
  )
  yield takeLatest(constants.CREATE_INVITE_USER_REQUEST, (action) => createInviteUserSaga(action))
  yield takeLatest(constants.UPDATE_INVITE_USER_REQUEST, (action) => updateInviteUserSaga(action))
  yield takeLatest(constants.RESEND_INVITE_USER_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.RESEND_INVITE_USER_REQUEST])
  )
  yield takeLatest(constants.REMOVE_USER_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.REMOVE_USER_REQUEST])
  )
  yield takeLatest(constants.GET_INVITE_USER_INFO_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.GET_INVITE_USER_INFO_REQUEST])
  )
  yield takeLatest(constants.REJECT_INVITE_USER_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.REJECT_INVITE_USER_REQUEST])
  )
  yield takeLatest(constants.ACCEPT_INVITE_USER_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.ACCEPT_INVITE_USER_REQUEST])
  )
  yield takeLatest(constants.LOGOUT_INVITE_USER_REQUEST, (action) =>
    apiGeneratorBase(action, eventsOptions[constants.LOGOUT_INVITE_USER_REQUEST])
  )
}
